import type { ApiAppointmentStatus } from '@/api/conversations/types/index.ts';
import Model from '@/entities/Model.js';

export type { ApiAppointmentStatus } from '@/api/conversations/types/index.ts';

export default class AppointmentStatus extends Model {
    declare confirmed: boolean;

    declare canceled: boolean;

    declare startAt: string | null;

    static get defaults() {
        return {
            confirmed: false,
            canceled: false,
            startAt: null,
        };
    }

    static fromApi(data: ApiAppointmentStatus): AppointmentStatus {
        return new AppointmentStatus({
            confirmed: data.confirmed,
            canceled: data.canceled,
            startAt: data.start_at,
        });
    }

    constructor(initialValues: Partial<AppointmentStatus> = {}) {
        super(initialValues);
    }
}
